import { render, staticRenderFns } from "./tabVersions.vue?vue&type=template&id=8d42afa8&scoped=true"
import script from "./tabVersions.vue?vue&type=script&lang=js"
export * from "./tabVersions.vue?vue&type=script&lang=js"
import style0 from "./tabVersions.vue?vue&type=style&index=0&id=8d42afa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d42afa8",
  null
  
)

export default component.exports